import { Box } from '@wix/design-system';
import { A11yPageListItem, RuleListStatus } from '@wix/rules-panel-ui';
import React, { useMemo } from 'react';
import { CrossPageNotification } from '../../../../verticals-drill-in/cross-page-notification';
import { PageTaskList } from '../lists/page-task-list';
import { SpecificPageTaskList } from '../lists/specific-page-task-list';
import { usePageListItemBase } from './use-page-list-item-base';
export const PageListItemCollapsible = /*#__PURE__*/React.memo(_ref => {
  let {
    pageId,
    isPageOpen,
    ruleResults,
    isSpecificPageList,
    isAllCrossPageIssuePassed
  } = _ref;
  const itemProps = usePageListItemBase({
    isPageOpen,
    isTpaPage: false,
    pageId,
    ruleResults
  });
  const shouldShowCrossPageNotification = useMemo(() => {
    const allRuleResultsPassed = ruleResults == null ? void 0 : ruleResults.every(ruleResult => ruleResult.status === RuleListStatus.passed);
    return isSpecificPageList && allRuleResultsPassed && !isAllCrossPageIssuePassed;
  }, [isSpecificPageList, ruleResults, isAllCrossPageIssuePassed]);
  const crossPageNotification = useMemo(() => {
    if (shouldShowCrossPageNotification) {
      return /*#__PURE__*/React.createElement(Box, {
        backgroundColor: "D80"
      }, /*#__PURE__*/React.createElement(CrossPageNotification, null));
    }
    return null;
  }, [shouldShowCrossPageNotification]);
  return /*#__PURE__*/React.createElement(A11yPageListItem, itemProps, isSpecificPageList && ruleResults ? /*#__PURE__*/React.createElement(SpecificPageTaskList, {
    pageId: pageId,
    ruleResults: ruleResults,
    topComponent: crossPageNotification
  }) : /*#__PURE__*/React.createElement(PageTaskList, {
    isPageOpen: isPageOpen,
    pageId: pageId,
    topComponent: crossPageNotification
  }));
});
//# sourceMappingURL=page-list-item-collapsible-wrapper.js.map